<cmps-dialog
    class="cmps-event-centre-c-pop-base-v2--dialog cmps-cdk-border-width-0p cmps-cdk-p-0"
    [class.cmps-event-centre-c-pop-dialog--multiple]="_data?.multiple"
>
    <cmps-dialog-header
        class="cmps-cdk-pt-0dot5 cmps-cdk-px-1"
        [closeTooltip]="_i18n._763_CLOSE | translate"
    >
        <div
            class="cmps-cdk-color-blue-100 cmps-cdk-font-bold cmps-cdk-font-size-36p cmps-cdk-py-0dot5"
        >
            {{ _data?.mapItem?.tpl?.title }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <div class="cmps-cdk-pos-relative">
            <div
                class="cmps-event-centre-c-pop-base-v2--dialog--bg"
                [style.background-image]="
                    'url(' + _data?.mapItem?.tpl?.titleImage + ')'
                "
            ></div>
            <div
                class="cmps-cdk-pos-absolute cmps-event-centre-c-pop-base-v2--dialog--bg-gradient"
            ></div>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-align-items-center cmps-cdk-mt-1 cmps-cdk-px-1"
        >
            <div
                class="cmps-cdk-w-70pct"
                #containerRef
            >
                <ng-container #ref></ng-container>
            </div>
        </div>
        <cmps-event-centre-c-pop-footer></cmps-event-centre-c-pop-footer>
    </cmps-dialog-body>
</cmps-dialog>
